exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__input::-moz-placeholder {\n  visibility: hidden;\n}\n.multiselect__input::placeholder {\n  visibility: hidden;\n}\n.additionalPopOverClass .popover-body {\n  overflow: hidden !important;\n  height: -moz-fit-content !important;\n  height: fit-content !important;\n}\n", ""]);

// exports
